import { AccountFeatureFlag } from '@/services/auth/feature-flags';
import type { RawAccount } from '@/services/auth/types';
import { isEligibleForOnboarding } from './completion';
import { ONBOARDING_PATHS } from './paths';

/** Just the raw-payload fields the selector reads; a full `RawAccount` satisfies it. */
export type PostSignupAccount = Pick<RawAccount, 'feature_flags' | 'account_state' | 'plan_slug'>;

/**
 * Where signup sends the new account once its workspace is provisioned. Takes
 * the raw payload because this runs before the auth stores are populated, so
 * `useAuth()` and the hooks built on it would throw.
 */
export function selectPostSignupDestination(account: PostSignupAccount): string {
  const eligibility = {
    isFlagEnabled: account.feature_flags?.[AccountFeatureFlag.EssentialsOnboarding] === true,
    account,
  };

  return isEligibleForOnboarding(eligibility) ? ONBOARDING_PATHS.wizard : '/';
}
